import { Component, Input, SimpleChanges, OnInit } from '@angular/core';
import { AnleggAar } from 'src/app/services/forbruk/forbruk.types';
import { toRoundNumber } from '../../../forbruk/forbrukstall/forbrukstall-utils';
import { hasChanged } from 'src/app/utils/change-utils';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-kostnadstall-year',
  templateUrl: './year.component.html',
  styleUrls: ['./year.component.scss']
})
export class KostnadstallYearComponent {
  @Input() valgtAnleggAar: AnleggAar;

  toRoundNumber = toRoundNumber;

  thisYear: number;
  isPlusskunde: boolean;
  yearsForbruk;
  isBrowser: boolean;

  constructor(private platform: Platform) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (hasChanged([changes.valgtAnleggAar])) {
      this.isBrowser =
        !this.platform.is('capacitor') && this.platform.width() >= 1200;
      this.getValues();
    }
  }

  getValues() {
    this.thisYear = new Date()?.getFullYear();
    this.isPlusskunde = this.valgtAnleggAar.plusskunde;
    this.yearsForbruk = this.valgtAnleggAar.aarVerdiList.map((x) => {
      // Skal være bakt inn plusskunde på totalen fra backend
      return {
        year: x.aar.toString(),
        sumKostnad: x.belop
      };
    });
  }
}
